"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelValue = void 0;
var react_1 = __importStar(require("react"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var prop_types_1 = __importDefault(require("prop-types"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            display: 'inline-flex',
            alignItems: 'center',
            lineHeight: 1.2,
            fontSize: function (props) { return props.fontSize; },
            color: function (props) { return props.color; },
        },
        icon: {
            marginRight: theme.spacing(0.5),
            display: 'inline',
            fontSize: 'inherit',
        },
        text: {
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 0,
        },
        units: {
            fontWeight: 300,
        },
        value: {
            fontWeight: 600,
        },
    });
});
var changeIconDisplay = function (newIcon) {
    return react_1.default.cloneElement(newIcon, {
        style: Object.assign({}, newIcon.props.style, { display: 'block', fontSize: 'inherit' }),
    });
};
var ChannelValueRender = function (props, ref) {
    var classes = props.classes, icon = props.icon, prefix = props.prefix, units = props.units, value = props.value, 
    // ignore unused vars so that we can do prop transferring to the root element
    /* eslint-disable @typescript-eslint/no-unused-vars */
    color = props.color, fontSize = props.fontSize, 
    /* eslint-enable @typescript-eslint/no-unused-vars */
    otherSpanProps = __rest(props, ["classes", "icon", "prefix", "units", "value", "color", "fontSize"]);
    var defaultClasses = useStyles(props);
    var getUnitElement = react_1.useCallback(function () { return (react_1.default.createElement(react_1.default.Fragment, null, units && (react_1.default.createElement(Typography_1.default, { variant: 'h6', color: 'inherit', className: clsx_1.default(defaultClasses.text, defaultClasses.units, classes.units), "data-test": 'units' }, units)))); }, [units, classes, defaultClasses]);
    return (react_1.default.createElement("span", __assign({ ref: ref, className: clsx_1.default(defaultClasses.root, classes.root), "data-test": 'wrapper' }, otherSpanProps),
        icon && (react_1.default.createElement("span", { className: clsx_1.default(defaultClasses.icon, classes.icon), "data-test": 'icon' }, changeIconDisplay(icon))),
        prefix && getUnitElement(),
        react_1.default.createElement(Typography_1.default, { variant: 'h6', color: 'inherit', className: clsx_1.default(defaultClasses.text, defaultClasses.value, classes.value), "data-test": 'value' }, value),
        !prefix && getUnitElement()));
};
/**
 * [ChannelValue](https://pxblue-components.github.io/react/?path=/info/components-channel-value--get-read-me-story) component
 *
 * Used to show a stylized value and its units.
 * You may also include an icon.
 */
exports.ChannelValue = react_1.default.forwardRef(ChannelValueRender);
exports.ChannelValue.displayName = 'ChannelValue';
exports.ChannelValue.propTypes = {
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
        icon: prop_types_1.default.string,
        value: prop_types_1.default.string,
        units: prop_types_1.default.string,
    }),
    color: prop_types_1.default.string,
    fontSize: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    icon: prop_types_1.default.element,
    prefix: prop_types_1.default.bool,
    units: prop_types_1.default.string,
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]).isRequired,
};
exports.ChannelValue.defaultProps = {
    classes: {},
    color: 'inherit',
    fontSize: 'inherit',
    prefix: false,
};
